// crewbit-admin/src/pages/Money/Settings/Notifications.tsx
//
// /money/settings/notifications — Notifications sub-screen.

import { useEffect } from 'react';
import { PageHeader } from '../../../components/common/PageHeader';
import NotificationsPanel from '../../../components/money/settings/NotificationsPanel';
import { admin, spacing } from '../../../styles/tokens';

const pageStyle: React.CSSProperties = {
  padding: spacing.xl,
  background: admin.bg,
  minHeight: '100vh',
};

export function MoneySettingsNotifications() {
  useEffect(() => {
    document.title = 'CrewBit · Notifications';
  }, []);

  return (
    <div style={pageStyle}>
      <PageHeader
        title="Notifications"
        description="Payments, disputes, tax due, payout alerts."
        back={{ to: '/money/settings', label: 'Money settings' }}
      />
      <NotificationsPanel />
    </div>
  );
}
